<template>
  <el-dialog title="Visualizar etiqueta" center :visible.sync="dialog" :before-close="close">
    <el-form size="mini">
      <el-row :gutter="5">
        <el-col :xs="15" :sm="10" :md="8" :lg="8" :xl="8">
          <el-form-item label="Objeto">
            <el-input v-model="record.tag" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item :label="$t('nome')" prop="destinyName">
            <el-input disabled v-model="record.destinyName" maxlength="60"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
          <el-form-item label="CEP Destino" prop="destinyZipcode">
            <el-input maxlength="9" disabled v-model="record.destinyZipcode"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="10" :lg="12" :xl="12">
          <el-form-item :label="$t('endereco')" prop="destinyAddress">
            <el-input disabled v-model="record.destinyAddress"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
          <el-form-item :label="$t('numero')" prop="destinyNumber">
            <el-input disabled type="number" maxlength="6" v-model="record.destinyNumber" v-mask="'######'"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="10" :md="10" :lg="9" :xl="9">
          <el-form-item :label="$t('cidade')" prop="destinyCity">
            <el-input disabled v-model="record.destinyCity"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
          <el-form-item :label="$t('estado')" prop="destinyState">
            <el-input disabled v-model="record.destinyState"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="12" :sm="10" :md="8" :lg="8" :xl="8">
          <el-form-item :label="$t('servico')" prop="service">
            <el-input v-model="record.service" disabled />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="10" :md="8" :lg="8" :xl="8">
          <el-form-item :label="$t('departamento')" prop="department">
            <el-input v-model="record.department" disabled />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="10" :md="6" :lg="6" :xl="6">
          <el-form-item :label="$t('altura')" prop="height">
            <el-input disabled v-model="record.height"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="6" :lg="6" :xl="6">
          <el-form-item :label="$t('comprimento')" prop="width">
            <el-input disabled v-model="record.width"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="6" :lg="6" :xl="6">
          <el-form-item :label="$t('largura')" prop="length">
            <el-input disabled v-model="record.length"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="6" :lg="6" :xl="6">
          <el-form-item :label="$t('peso')" prop="weight">
            <el-input disabled v-model="record.weight"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="10" :md="6" :lg="6" :xl="6">
          <el-form-item :label="$t('valor-declarado')" prop="declaredValue">
            <el-input disabled type="number" v-model="record.declaredValue"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="6" :lg="6" :xl="6">
          <el-form-item label="Tabela" prop="pricetable">
            <el-input disabled v-model="record.pricetable"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="6" :lg="6" :xl="6" v-show="userType !== '2' && userType !== '5'">
          <el-form-item :label="$t('valor')" prop="courier">
            <el-input disabled v-model="record.courier"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="10" :md="10" :lg="24" :xl="24">
          <el-form-item :label="$t('observacao')" prop="observation">
            <el-input type="textarea" disabled v-model="record.observation"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialog = false">OK</el-button>
    </span>
  </el-dialog>
</template>
<script>

export default {
  name: "HistorySgpDetail",
  props: ["userType"],
  data() {
    return {
      dialog: false,
      record: {}
    };
  },
  methods: {
    open(record) {
      this.record = record.data;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>
